import { IBuildingStackSyncSettings } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { ActionContext } from 'vuex';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { getNewBuildingStackSyncSettings } from '@/shared/factory/new-building-stack-sync-settings';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/building-stack-api/building_stack_sync_settings';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IBuildingStackSyncSettings>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  showLogging,
});

type TBuildingStackSyncSettingsState = {
  single: IBuildingStackSyncSettings
};

export default {
  namespaced: base.namespaced, // 'building_stack_sync_settings/'

  state: {
    ...base.state,
    single: {},
  },

  getters: {
    ...base.getters,
    single: (state: TBuildingStackSyncSettingsState): IBuildingStackSyncSettings => state.single ?? getNewBuildingStackSyncSettings(),
  },

  mutations: {
    ...base.mutations,
    setSyncSettings(state: TBuildingStackSyncSettingsState, payload: IBuildingStackSyncSettings): void {
      state.single = payload;
    },
  },

  actions: {
    ...base.actions,
    async get(ctx: ActionContext<TBuildingStackSyncSettingsState, (typeof base.state)>, clientId: number) {
      const result = await adminRequest.get(`${adminGatewayResourcePath}?alias=bsss&where=bsss.clientId:${clientId}`);
      ctx.commit('setSyncSettings', result.data?.length ? result.data[0] : getNewBuildingStackSyncSettings());
    },
    update: async (
      ctx: ActionContext<TBuildingStackSyncSettingsState, (typeof base.state)>,
      payload: { identifiers: Record<string, number>, payload: IBuildingStackSyncSettings }[],
    ) => {
      await adminRequest.put(adminGatewayResourcePath, payload);
    },
  },
};
